import { SectionHeading } from './ui';

const TERMS = [
  {
    icon: 'ri-wallet-3-line',
    title: 'Số dư tài khoản',
    desc: 'Số tiền giao dịch có sẵn trong tài khoản của bạn.',
  },
  {
    icon: 'ri-pie-chart-line',
    title: 'Mức rủi ro',
    desc: 'Tỷ lệ phần trăm số dư mà bạn chấp nhận rủi ro cho một giao dịch.',
  },
  {
    icon: 'ri-stop-circle-line',
    title: 'Stop Loss',
    desc: 'Khoảng cách (tính bằng Pip) giữa giá vào lệnh và giá cắt lỗ.',
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Giá trị Pip',
    desc: 'Mức thay đổi giá trị tài khoản khi giá biến động một Pip.',
  },
];

const SYMBOLS = [
  { sym: 'Khối lượng', meaning: 'Số lot giao dịch' },
  { sym: 'Số tiền rủi ro', meaning: 'Số tiền chấp nhận mất nếu chạm Stop Loss' },
  { sym: 'Stop Loss', meaning: 'Khoảng cách cắt lỗ (pip)' },
  { sym: 'Giá trị Pip', meaning: 'Giá trị tiền của 1 pip' },
  { sym: 'Số dư tài khoản', meaning: 'Tiền có sẵn trong tài khoản' },
  { sym: 'Mức rủi ro', meaning: '% rủi ro mỗi lệnh' },
];

export default function FormulaSection() {
  return (
    <section>
      <SectionHeading
        eyebrow="Công thức"
        title="Công thức tính khối lượng"
        subtitle="Công thức đơn giản đứng sau mọi phép tính khối lượng giao dịch."
      />

      <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-2">
        <div className="rounded-2xl border border-violet-100 bg-gradient-to-br from-violet-50 to-white p-6 md:p-8">
          <p className="text-xs font-semibold uppercase tracking-wider text-violet-500">Công thức chính</p>
          <p className="mt-4 font-mono text-lg font-bold leading-relaxed text-slate-800 md:text-xl">
            Khối lượng = Số tiền rủi ro
            <span className="text-violet-600"> ÷ </span>
            (Stop Loss
            <span className="text-violet-600"> × </span>
            Giá trị Pip)
          </p>
          <div className="mt-5 h-px w-full bg-slate-200" />
          <p className="mt-5 font-mono text-sm font-semibold text-slate-600">
            Số tiền rủi ro = Số dư tài khoản
            <span className="text-violet-600"> × </span>
            Mức rủi ro
          </p>
          <div className="mt-5 h-px w-full bg-slate-200" />
          <p className="mt-4 text-[10px] font-semibold uppercase tracking-wide text-slate-400">Ký hiệu</p>
          <div className="mt-2 flex flex-wrap gap-2">
            {SYMBOLS.map((s) => (
              <span
                key={s.sym}
                className="inline-flex items-center gap-1.5 rounded-lg bg-white px-2.5 py-1.5 text-[11px] ring-1 ring-violet-100"
              >
                <span className="font-mono font-semibold text-violet-600">{s.sym}</span>
                <span className="text-slate-500">{s.meaning}</span>
              </span>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          {TERMS.map((t) => (
            <div key={t.title} className="rounded-2xl border border-slate-200/80 bg-white p-5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-violet-50 text-violet-600">
                <i className={t.icon} />
              </span>
              <p className="mt-3 text-sm font-semibold text-slate-800">{t.title}</p>
              <p className="mt-1 text-xs leading-relaxed text-slate-400">{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}